import { Theme } from "../../react-components-core";

export const typography: Theme["typography"] = {
    h1: {
        component: "h1",
        style: {
            fontSize: "3.75rem",
        },
    },
    h2: {
        component: "h2",
        style: {
            fontSize: "3rem",
        },
    },
    h3: {
        component: "h3",
        style: {
            fontSize: "2rem",
        },
    },
    h4: {
        component: "h4",
        style: {
            fontSize: "1.75rem",
        },
    },
    h5: {
        component: "h5",
        style: {
            fontSize: "1.5rem",
        },
    },
    h6: {
        component: "h6",
        style: {
            fontSize: "1.25rem",
        },
    },
    subtitle1: {
        component: "h6",
        style: {
            fontSize: "1rem",
        },
    },
    subtitle2: {
        component: "h6",
        style: {
            fontSize: "0.875rem",
        },
    },
    body1: {
        component: "p",
        style: {
            fontSize: "1rem",
        },
    },
    body2: {
        component: "p",
        style: {
            fontSize: "0.875rem",
        },
    },
    button: {
        component: "span",
        style: {
            fontSize: "0.875rem",
            textTransform: "uppercase",
        },
    },
    caption: {
        component: "span",
        style: {
            fontSize: "0.75rem",
        },
    },
};
